import { setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import serviceNames, { ProductService } from '~setup/ProductService';
import {
    PRODUCT_CTA,
    PRODUCT_FULL,
    PRODUCT_GRID,
    PRODUCT_CROSS_SELL,
    PRODUCT_MEDIA_CAROUSEL_NAV,
    PRODUCT_QUANTITY_SELECTOR,
    PRODUCT_RATING_WRAPPER,
    PRODUCT_SIZE_PICKER,
    PRODUCT_SHADE_PICKER,
    PRODUCT_SHADE_PICKER_BUTTON,
    PRODUCT_BASIC_INFO,
    PRODUCT_FULL_ORDERABLE, // @todo - remove in MPPFIND-4088
    PRODUCT_COMPARISON_MODULE,
    PRODUCT_BRIEF
} from '@estee/elc-service-view-names';
import { serviceBusBaseClass } from './service-setup/ServiceBus';

setupServiceInfo(__serviceInfo__);

const { name, version } = __serviceInfo__;

ProductService.setViews(name, name.replace(/-/g, '_'), version, [
    PRODUCT_CTA,
    PRODUCT_BRIEF,
    PRODUCT_FULL,
    PRODUCT_GRID,
    PRODUCT_CROSS_SELL,
    PRODUCT_MEDIA_CAROUSEL_NAV,
    PRODUCT_QUANTITY_SELECTOR,
    PRODUCT_RATING_WRAPPER,
    PRODUCT_SIZE_PICKER,
    PRODUCT_SHADE_PICKER,
    PRODUCT_SHADE_PICKER_BUTTON,
    PRODUCT_BASIC_INFO,
    PRODUCT_FULL_ORDERABLE, // @todo - remove in MPPFIND-4088
    PRODUCT_COMPARISON_MODULE
]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.productService,
    serviceBusControllerKey: serviceNames.serviceBusController,
    serviceBusBaseClass
});
